function matchheight() {
 
     jQuery(".image-with-text__text-content p").matchHeight();
  
      jQuery('div[id*=_165406738229739f4d] .card__text .h3').matchHeight();
      jQuery('div[id*=_165406738229739f4d] span.text-size--large').matchHeight();
      jQuery('.product-item.card .product-item__image').matchHeight();
      jQuery('.product-item.card .product-price').matchHeight();
      jQuery('.product-item.card a.product-item__title').matchHeight();
      jQuery('.template-customers-addresses .account-widget__body p').matchHeight();
      jQuery('.footer-item h4.footer-item__title.h5').matchHeight();

      jQuery('.product-item__text .remove-line-height-space--medium ').matchHeight();

      jQuery('div[id*=_16551074833cdf378e] .h1').matchHeight();

      jQuery('.site-nav.style--classic .submenu.mega-menu .has-babymenu>.menu-link').matchHeight();

      jQuery('.product-listing-page .mount-css-slider .h5').matchHeight();
      jQuery('.product-listing-page .mount-css-slider .text-size--small').matchHeight();

      jQuery('div[id*=_165597098555c514a4] .h5').matchHeight();
      jQuery('div[id*=_165597098555c514a4] .text-size--small').matchHeight();
      jQuery('div[id*=_75ba6d85-079b-4d4e-a077-ea11d6a34907] .h5').matchHeight();

     jQuery('div[id*=_75ba6d85-079b-4d4e-a077-ea11d6a34907] .text-size--small').matchHeight();

      jQuery('div[id*=_1654161920efe5f084] .h5').matchHeight();
      jQuery('div[id*=_1654161920efe5f084] .text-size--small').matchHeight();

      
}


	
  matchheight();







$(window).on("load", function () {    
 matchheight();
 
});

